module.exports = __webpack_public_path__ + "img/info-prod-reprovado.a34a3959.svg";